import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import TopBar from "./components/TopBar/TopBar";
import Home from "./components/Home/Home";
import Projects from "./components/Projects/Projects";
import Scenarios from "./components/Scenarios/Scenarios";
import ScenarioManager from "./components/Scenarios/ScenarioManager";
// import PanelLayoutEnhanced from "./components/PanelLayout/PanelLayoutEnhanced";
import Layout from "./components/Layouts/Layout";
// import MasterData from "./components/DataConfiguration/MasterData/MasterData";
import MasterDataArticles from "./components/DataConfiguration/MasterData/MasterDataArticles";
import MasterDataGlobalLibrary from "./components/DataConfiguration/MasterData/MasterDataGlobalLibrary";
import { EmbedSetup, EmbedViewer, EmbedDevices } from "./components/Embed/EmbedPages";
import { installNumberInputBehavior } from "./components/Common/numberInputBehavior";
import "./App.css";

// Evaluated once: stays true when navigating inside the iframe (e.g. to /scenarios/:id)
const IN_IFRAME = window.self !== window.top;

function AppRoutes() {
    const { pathname } = useLocation();
    const embedded = IN_IFRAME || pathname.startsWith("/embed");

    return (
        <>
            {!embedded && <TopBar />}

            <main className={embedded ? "main-content main-content--embed" : "main-content"}>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/scenarios" element={<Scenarios />} />
                    <Route path="/partslibrary" element={<MasterDataArticles />} />
                    <Route path="/globallibrary" element={<MasterDataGlobalLibrary />} />

                    {/* Panel editor route */}
                    {/* <Route path="/projects/:projectId" element={<PanelLayoutEnhanced />} /> */}
                    <Route path="/projects/:projectId" element={<Layout />} />

                    <Route path="/scenarios/:scenarioId" element={<ScenarioManager />} />

                    {/* Embeddable panels: paths must match PANELS in the host config */}
                    <Route path="/embed/setup" element={<EmbedSetup />} />
                    <Route path="/embed/viewer" element={<EmbedViewer />} />
                    <Route path="/embed/devices" element={<EmbedDevices />} />
                    <Route path="/embed/:projectId/setup" element={<EmbedSetup />} />
                    <Route path="/embed/:projectId/viewer" element={<EmbedViewer />} />
                    <Route path="/embed/:projectId/devices" element={<EmbedDevices />} />
                </Routes>
            </main>
        </>
    );
}

function App() {
    // Number inputs: select the whole value on focus (the install function returns its cleanup)
    useEffect(() => installNumberInputBehavior(), []);

    return (
        <BrowserRouter>
            <AppRoutes />
        </BrowserRouter>
    );
}

export default App;